import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const TypeModule = ({ phraseLibrary, speed = 150 }) => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [textSpeed, setTextSpeed] = useState(speed);
  const [loop, setLoop] = useState(0);

  const i = loop % phraseLibrary.length;
  const phrase = phraseLibrary[i];

  const TypePhrase = () => {
    // type out phrase char by char or delete phrase char by char
    setText(
      isDeleting
        ? phrase.substring(0, text.length - 1)
        : phrase.substring(0, text.length + 1)
    );

    // set speeds for deleting phrase v. typing phrase to mimic analog typing behavior better
    setTextSpeed(isDeleting ? 80 : speed);

    // once entire phrase has been typed out, pause before deleting - similarly, if entire phrase has been deleted, pause before looping to next phrase in the phraseLibrary
    if (!isDeleting && text === phrase) {
      setTimeout(() => setIsDeleting(true), 800);
    } else if (isDeleting && text === '') {
      setTimeout(() => {
        setIsDeleting(false);
        setLoop(loop + 1);
      }, 500);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      TypePhrase();
    }, textSpeed);
    return () => clearTimeout(timer);
  });

  return (
    <React.Fragment>
      <span id="text" aria-label={phrase}>
        {text}
      </span>
      <span id="cursor" />
    </React.Fragment>
  );
};

TypeModule.propTypes = {
  phraseLibrary: PropTypes.arrayOf(PropTypes.shape(TypeModule.propTypes)),
  speed: PropTypes.number,
};

export default TypeModule;
